import {
  Button,
  Card,
  Checkbox,
  Col,
  DatePicker,
  Flex,
  Form,
  Popover,
  Row,
  Typography,
  Image,
  List,
  Rate,
  Space,
  Badge,
  Drawer,
  Table,
  Tag,
  Select,
  Grid,
} from "antd";
import cat1 from "assets/images/cat1.png";
import "../../product-component/productComponent.scss";
import calendar from "assets/images/calendar.svg";

import {
  CalendarOutlined,
  CheckCircleOutlined,
  InfoCircleFilled,
  UnorderedListOutlined,
} from "@ant-design/icons";
import React, { useRef, useState } from "react";
import dayjs, { Dayjs } from "dayjs"; // Import Dayjs and types
const { Title, Text } = Typography;

const MailIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 20 16"
  >
    <path
      d="M0.666748 1.60041C1.15882 0.943277 1.94117 0.517029 2.81939 0.517029H17.1808C18.059 0.517029 18.8414 0.943277 19.3334 1.6004L10.0001 8.42135L0.666748 1.60041Z"
      fill="#A7833F"
    />
    <path
      d="M0 3.15183V13.6487C0 15.1231 1.2252 16.3257 2.72727 16.3257H17.2727C18.7748 16.3257 20 15.1231 20 13.6487V3.15182L11.0694 9.52706C10.4318 9.98215 9.56818 9.98215 8.93064 9.52706L0 3.15183Z"
      fill="#A7833F"
    />
  </svg>
);

const data = ["Instant Confirmation", "Non Refundable"];

const tourList = [
  {
    key: "1",
    text: "Dubai Fountain Show Lake ride Tickets",
    link: "https://example.com/item1",
  },
  {
    key: "2",
    text: "Burj Khalifa Level 124 + The Roof Top Meal tickets prime",
    link: "https://example.com/item2",
  },
  {
    key: "3",
    text: "Dubai Fountain Walk Bridge Tickets",
    link: "https://example.com/item3",
  },
  {
    key: "4",
    text: "124th + 125th Floor Non-Prime Hours Tickets",
    link: "https://example.com/item3",
  },
];

const handleChange = (value: any) => {
  console.log(`selected ${value}`);
};
const onChange = (date: any, dateString: any) => {
  console.log(date, dateString);
};
const columns = [
  {
    title: "Tour Option",
    dataIndex: "name",
    key: "name",
    render: (_: any, record: any) => (
      <Flex>
        <Checkbox
          className="checkbox-danger"
          defaultChecked={record.checked}
          checked
        >
          Ferrari World Entry Ticket -Dated
        </Checkbox>
        <Popover content={"Info content this year"}>
          <Button
            style={{
              color: "#69c0ff",
              borderColor: "transparent",
            }}
            type="link"
          >
            <InfoCircleFilled />
          </Button>
        </Popover>
      </Flex>
    ),
  },
  {
    title: "Transfer Option",
    dataIndex: "age",
    key: "age",
    render: (_: any, record: any) => (
      <Select
        defaultValue=""
        style={{
          width: 120,
        }}
        onChange={handleChange}
        options={[
          {
            value: "jack",
            label: "Jack",
          },
          {
            value: "lucy",
            label: "Lucy",
          },
          {
            value: "Yiminghe",
            label: "yiminghe",
          },
          {
            value: "disabled",
            label: "Disabled",
            disabled: true,
          },
        ]}
      />
    ),
  },
  {
    title: "Tour Date",
    dataIndex: "address",
    key: "address",
    render: (_: any, record: any) => (
      <DatePicker
        prefix={<img src={calendar} />}
        className="w-100"
        onChange={onChange}
        suffixIcon={null}
      />
    ),
  },
  {
    title: "Adult",
    dataIndex: "address",
    key: "address",
    render: (_: any, record: any) => (
      <Select
        defaultValue=""
        style={{
          width: 60,
        }}
        onChange={handleChange}
        options={[
          {
            value: "jack",
            label: "Jack",
          },
          {
            value: "lucy",
            label: "Lucy",
          },
          {
            value: "Yiminghe",
            label: "yiminghe",
          },
          {
            value: "disabled",
            label: "Disabled",
            disabled: true,
          },
        ]}
      />
    ),
  },
  {
    title: "Child",
    dataIndex: "address",
    key: "address",
    render: (_: any, record: any) => (
      <Select
        defaultValue=""
        style={{
          width: 60,
        }}
        onChange={handleChange}
        options={[
          {
            value: "jack",
            label: "Jack",
          },
          {
            value: "lucy",
            label: "Lucy",
          },
          {
            value: "Yiminghe",
            label: "yiminghe",
          },
          {
            value: "disabled",
            label: "Disabled",
            disabled: true,
          },
        ]}
      />
    ),
  },
  {
    title: "Infant",
    dataIndex: "address",
    key: "address",
    render: (_: any, record: any) => (
      <Select
        defaultValue=""
        style={{
          width: 60,
        }}
        onChange={handleChange}
        options={[
          {
            value: "jack",
            label: "Jack",
          },
          {
            value: "lucy",
            label: "Lucy",
          },
          {
            value: "Yiminghe",
            label: "yiminghe",
          },
          {
            value: "disabled",
            label: "Disabled",
            disabled: true,
          },
        ]}
      />
    ),
  },
  {
    title: "Total amount",
    dataIndex: "address",
    key: "address",
    render: (_: any, record: any) => (
      <>
        <Typography.Title level={5} className="mt-0 mb-0 font-13">
          AED 309.75
        </Typography.Title>
        <Text className="font-11">Earn 200 R Points</Text>
      </>
    ),
    // AED 309.75
  },
];

const columnsMobile = [
  {
    title: "Details",
    dataIndex: "details",
    key: "details",
    render: (_: any, record: any) => {
      console.log("Record Data:", record);
      return (
        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
          <div>
            <strong>Tour Option:</strong>
            <br />
            <Checkbox defaultChecked={record.checked}>{record.title}</Checkbox>
          </div>
          <div>
            <strong>Transfer Option:</strong>
            <br />
            <Select
              className="w-100"
              defaultValue={record.transfer}
              options={[
                { value: "jack", label: "Jack" },
                { value: "lucy", label: "Lucy" },
                { value: "Yiminghe", label: "Yiminghe" },
                { value: "disabled", label: "Disabled", disabled: true },
              ]}
            />
          </div>
          <div>
            <strong>Tour Date:</strong>
            <br />
            <DatePicker defaultValue={record.date} className="w-100" />
          </div>
          <div>
            <strong>Adult:</strong>
            <br />
            <Select
              className="w-100"
              defaultValue=""
              onChange={handleChange}
              options={[
                {
                  value: "jack",
                  label: "Jack",
                },
                {
                  value: "lucy",
                  label: "Lucy",
                },
                {
                  value: "Yiminghe",
                  label: "yiminghe",
                },
                {
                  value: "disabled",
                  label: "Disabled",
                  disabled: true,
                },
              ]}
            />
          </div>
          <div>
            <strong>Child:</strong>
            <br />
            <Select
              className="w-100"
              defaultValue=""
              onChange={handleChange}
              options={[
                {
                  value: "jack",
                  label: "Jack",
                },
                {
                  value: "lucy",
                  label: "Lucy",
                },
                {
                  value: "Yiminghe",
                  label: "yiminghe",
                },
                {
                  value: "disabled",
                  label: "Disabled",
                  disabled: true,
                },
              ]}
            />
          </div>
          <div>
            <strong>Infant:</strong>
            <br />
            <Select
              className="w-100"
              defaultValue=""
              onChange={handleChange}
              options={[
                {
                  value: "jack",
                  label: "Jack",
                },
                {
                  value: "lucy",
                  label: "Lucy",
                },
                {
                  value: "Yiminghe",
                  label: "yiminghe",
                },
                {
                  value: "disabled",
                  label: "Disabled",
                  disabled: true,
                },
              ]}
            />
          </div>
          <div>
            <strong>Total Amount:</strong>
            <br />
            <Title level={5} className="mt-0 mb-0 font-13">
              {record.totalAmount.amount}
            </Title>
            <Text className="font-11">{record.totalAmount.points}</Text>
          </div>
        </div>
      );
    },
  },
];

const dataSource = [
  {
    key: "1",
    title: "Ferrari World Entry Ticket -Dated",
    totalAmount: { amount: "AED 309.75", points: "Earn 200 R Points" },
  },
  {
    key: "2",
    title: "Ferrari World Entry Ticket -Dated",
    totalAmount: { amount: "AED 309.75", points: "Earn 200 R Points" },
  },
];

function ProductListComponent({ onTrigger }: any) {
  const [open, setOpen] = useState(false);
  const [showTicket, setShowTicket] = useState(false);

  const showLargeDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };

  const showTicketsDetails = () => {
    setShowTicket(true);
  };

  const today = dayjs();
  const [openDate, setOpenDate] = useState(false);
  const [selectedDate, setSelectedDate] = useState<string>(
    today.format("dddd, DD MMMM YYYY")
  ); // Default to today's date
  const handleDateChange = (date: Dayjs | null) => {
    if (date) {
      // Format the selected date
      const formattedDate = date.format("dddd, DD MMMM YYYY");
      setSelectedDate(formattedDate);
    } else {
      setSelectedDate("No date selected"); // Handle case when date is cleared
    }
  };

  const [childrenDrawer, setChildrenDrawer] = useState(false);
  const showChildrenDrawer = () => {
    setChildrenDrawer(true);
  };
  const onChildrenDrawerClose = () => {
    setChildrenDrawer(false);
  };

  const cards = [
    {
      id: 1,
      title: "17:45 (37)",
      adultPrice: 65.0,
      childPrice: 65.0,
      key: "Available",
    },
    {
      id: 2,
      title: "18:30 (40)",
      adultPrice: 70.0,
      childPrice: 70.0,
      key: "SoldOut",
    },
    {
      id: 3,
      title: "19:15 (50)",
      adultPrice: 80.0,
      childPrice: 80.0,
      key: "Availability",
    },
    {
      id: 4,
      title: "19:15 (50)",
      adultPrice: 80.0,
      childPrice: 80.0,
      key: "Available",
    },
    {
      id: 5,
      title: "19:15 (50)",
      adultPrice: 80.0,
      childPrice: 80.0,
      key: "Available",
    },
  ]; // Example data

  const [selectedCard, setSelectedCard] = useState(null); // Track selected card

  const handleCardClick = (cardId: any) => {
    setSelectedCard(cardId === selectedCard ? null : cardId); // Toggle selection
  };

  const flags = [
    { code: "us", name: "United States", icon: "🇺🇸" },
    { code: "fr", name: "France", icon: "🇫🇷" },
    { code: "in", name: "India", icon: "🇮🇳" },
  ];

  const [selectedFlag, setSelectedFlag] = useState(flags[0]); // Default flag
  const [form] = Form.useForm();
  // Handle flag selection
  const handleFlagSelect = (flag: any) => {
    setSelectedFlag(flag); // Update selected flag
    form.setFieldValue("flag", flag.code); // Update form value for "flag"
  };
  type SizeType = Parameters<typeof Form>[0]["size"];
  const [componentSize, setComponentSize] = useState<SizeType | "default">(
    "default"
  );
  const variant = Form.useWatch("variant", form);

  const proceedButton = () => {
    onClose();
    onTrigger("Triggered from ProductListComponent!");
  };

  const { useBreakpoint } = Grid; // Correct way to use it
  const screens = useBreakpoint(); // Ensures screens is defined

  return (
    <>
      <Drawer
        title={showTicket ? `The Burj Khalifa Tickets` : `Select Option`}
        placement="right"
        size={"large"}
        open={open}
        width={1000} // Custom width
        extra={
          <Space>
            <Button onClick={onClose}>Close</Button>
          </Space>
        }
      >
        {!showTicket && (
          <>
            <Table
              dataSource={dataSource}
              columns={screens.lg ? columns : columnsMobile}
              className="selectOptionsTable mt-4 responsiveTable"
              bordered
            />
            <Flex align="center" justify="flex-end" className="mt-3" gap={15}>
              <Button
                className="px-4"
                type="primary"
                danger
                color="danger"
                variant="outlined"
              >
                Add to Email Flyer
              </Button>
              <Button
                className="px-4"
                type="primary"
                danger
                color="danger"
                variant="solid"
                onClick={showTicketsDetails}
              >
                Add to Cart
              </Button>
            </Flex>
          </>
        )}

        {showTicket && (
          <>
            <Flex
              gap={15}
              justify="flex-start"
              vertical={screens.lg ? false : true}
            >
              <Flex align="center" gap={15}>
                <Title level={5} className="primary-color mb-0 mt-0">
                  <CalendarOutlined /> {selectedDate ? selectedDate : ""}
                </Title>
                <Button
                  type="primary"
                  size="small"
                  onClick={() => setOpenDate(true)}
                >
                  Change
                </Button>
                <DatePicker
                  onChange={handleDateChange}
                  style={{ visibility: "hidden", width: "0" }}
                  open={openDate}
                  className="p-0"
                  onOpenChange={(status) => setOpenDate(status)} // Close the calendar when a date is selected or clicked away
                />
              </Flex>

              <Flex align="center" gap={15}>
                <Title level={5} className="primary-color mb-0 mt-0">
                  <CalendarOutlined /> {selectedDate ? selectedDate : ""}
                </Title>

                <Button
                  size="small"
                  type="primary"
                  onClick={showChildrenDrawer}
                >
                  Change
                </Button>
                <Drawer
                  title="The Burj Khalifa Tickets"
                  size={"large"}
                  closable={false}
                  onClose={onChildrenDrawerClose}
                  open={childrenDrawer}
                  extra={
                    <Space>
                      <Button onClick={onChildrenDrawerClose}>Close</Button>
                    </Space>
                  }
                >
                  <Title level={5} className="primary-color mb-0 mt-0">
                    <UnorderedListOutlined /> Select Tour Option
                  </Title>
                  <List
                    size="small"
                    bordered={false}
                    dataSource={tourList}
                    className="mt-4"
                    renderItem={(item) => (
                      <List.Item>
                        <Tag
                          bordered={false}
                          color="error"
                          className="px-3 py-2"
                        >
                          <Button type="link" className="p-0">
                            {item.key}. {item.text}
                          </Button>

                          {/* <Text color="primary">  {item.key}.) {item.text} </Text> */}
                        </Tag>
                      </List.Item>
                    )}
                  />
                  {/* Dubai Fountain Show Lake ride Tickets */}
                </Drawer>
              </Flex>
            </Flex>

            <hr className="my-3" />
            <Title level={5} className="primary-color mb-0 mt-0">
              Select Time Options
            </Title>

            <div className="ticketDetails mt-3">
              <Flex gap={30} className="p-4">
                <Badge
                  className="responsiveBadge"
                  color="green"
                  text="Available"
                />
                <Badge
                  className="responsiveBadge"
                  color="red"
                  text="Sold Out"
                />
                <Badge
                  className="responsiveBadge"
                  color="yellow"
                  text="Limited Availability"
                />
              </Flex>
              <hr className="" />
              <Flex gap={16} wrap="wrap" className="p-4">
                {cards.map((card) => (
                  <Card
                    key={card.id}
                    size="small"
                    title={
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <span>{card.title}</span>
                        {selectedCard === card.id && (
                          <CheckCircleOutlined
                            style={{
                              width: "24px",
                              fontSize: "24px",
                              color: "#ffffff",
                            }}
                          />
                        )}
                      </div>
                    }
                    className={`text-center ticketCard 
                      ${card.key === "Available" ? "available-ticket" : ""} 
                      ${card.key === "SoldOut" ? "sold-ticket" : ""} 
                      ${
                        card.key === "Availability" ? "availability-ticket" : ""
                      } 
                      ${selectedCard === card.id ? "selected" : ""}`}
                    onClick={() => handleCardClick(card.id)}
                    style={{
                      cursor: "pointer",
                      boxShadow:
                        selectedCard === card.id
                          ? "rgba(0, 0, 0, 0.1) 0px 0px 2px 1px"
                          : "",
                    }}
                  >
                    Adult : AED {card.adultPrice.toFixed(2)} <br />
                    Child : AED {card.childPrice.toFixed(2)}
                  </Card>
                ))}
              </Flex>
            </div>

            <div className="ticketDetails mt-4 p-4">
              <Form
                layout="vertical"
                initialValues={{ variant: "filled", size: componentSize }}
                variant={variant || "filled"}
                form={form}
                size={"large"}
              >
                <Row gutter={[16, 16]} className="mt-3 mb-4">
                  <Col xs={24} sm={24} md={24} lg={8}>
                    <Form.Item
                      label="Adult 1 x AED 65.00"
                      name="adult"
                      className="mb-0"
                    >
                      <Select
                        defaultValue="1"
                        onChange={handleChange}
                        options={[
                          { value: "1", label: "1" },
                          { value: "2", label: "2" },
                          { value: "3", label: "3" },
                          { value: "4", label: "4" },
                          { value: "5", label: "5" },
                          { value: "6", label: "6" },
                        ]}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={8}>
                    <Form.Item
                      label="Child 0 x AED 65.00"
                      name="child"
                      className="mb-0"
                    >
                      <Select
                        defaultValue="0"
                        onChange={handleChange}
                        options={[
                          { value: "0", label: "0" },
                          { value: "1", label: "1" },
                          { value: "2", label: "2" },
                          { value: "3", label: "3" },
                          { value: "4", label: "4" },
                          { value: "5", label: "5" },
                          { value: "6", label: "6" },
                        ]}
                      />
                    </Form.Item>
                  </Col>

                  <Col xs={24} sm={24} md={24} lg={8}>
                    <Form.Item
                      label="Infant 0 x AED 0.00"
                      name="infant"
                      className="mb-0"
                    >
                      <Select
                        defaultValue="0"
                        onChange={handleChange}
                        options={[
                          { value: "0", label: "0" },
                          { value: "1", label: "1" },
                          { value: "2", label: "2" },
                          { value: "3", label: "3" },
                          { value: "4", label: "4" },
                          { value: "5", label: "5" },
                          { value: "6", label: "6" },
                        ]}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
              <Flex align="center" justify="space-between">
                <Title level={4} className="mb-0 mt-0">
                  Total AED 65.00
                </Title>

                <Button
                  className="px-4"
                  type="primary"
                  danger
                  color="danger"
                  variant="solid"
                  onClick={proceedButton}
                >
                  Proceed
                </Button>
              </Flex>
            </div>
          </>
        )}
      </Drawer>
      <Card className="light-sky-color mb-3" size="small">
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={24} md={6} lg={8} xl={6}>
            <Image height={"100%"} preview={false} width={"100%"} src={cat1} />
          </Col>
          <Col xs={24} sm={16} md={12} lg={8} xl={12}>
            <Flex
              justify={"space-between"}
              align={"start"}
              vertical
              className="h-100"
            >
              <Typography.Title level={5} className="mt-0">
                Burj Al Arab Restaurants
              </Typography.Title>

              <Button type="primary" className="email-flyer" size="small">
                <MailIcon /> Add To Email Flyer
              </Button>

              <List
                size="small"
                bordered={false}
                dataSource={data}
                className="product-list mt-4"
                renderItem={(item) => (
                  <List.Item>
                    <CheckCircleOutlined style={{ paddingRight: "10px" }} />
                    {item}
                  </List.Item>
                )}
              />

              <Flex className="mt-3" wrap={"wrap"} gap={10}>
                <Button size="small">About The Experience</Button>
                <Button size="small">Inclusions</Button>
                <Button size="small">Important Information</Button>
              </Flex>
            </Flex>
          </Col>
          <Col xs={24} sm={8} md={6} lg={8} xl={6}>
            <Flex
              justify={"space-between"}
              align={"end"}
              vertical
              className="h-100 flex-align-start-xs"
            >
              <Flex
                justify={"center"}
                align={"center"}
                vertical
                className="flex-align-start-xs"
              >
                <Rate
                  allowHalf
                  defaultValue={5}
                  className="rate-danger ml-auto"
                />
                <small className="d-block mt-1">6 Reviews</small>
              </Flex>

              <Flex
                justify={"end"}
                align={"end"}
                vertical
                className="flex-align-start-xs"
              >
                <small className="d-block">from AED</small>
                <Typography.Title level={4} className="mt-0">
                  415.00
                </Typography.Title>
                <Button
                  type="primary"
                  size="large"
                  danger
                  className="px-5"
                  onClick={showLargeDrawer}
                >
                  Select
                </Button>
              </Flex>
            </Flex>
          </Col>
        </Row>
      </Card>
    </>
  );
}

export default ProductListComponent;
